export default "__VITE_ASSET__VQ7xYwvG__"